import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { MileageReminderNotNotified } from "../../http/mileages/types";
import { ErrorBox } from "../ui/Boxes";
import FormFieldsContainer from "../ui/FormFieldsContainer";
import ModalDialog from "../ui/ModalDialog";
import Table from "../ui/Table";

type MileageRemindersNotNotifiedDialogProps = {
  notNotified: MileageReminderNotNotified[];
  onClose: () => void;
};

const MileageRemindersNotNotifiedDialog: FC<MileageRemindersNotNotifiedDialogProps> = ({ notNotified, onClose }) => {
  const i18n = useI18n();

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.mileages.notNotifiedDialog.title}
      isSubmitting={false}
      actions={[
        {
          title: i18n.t.common.close,
          onClick: onClose,
        },
      ]}
    >
      <FormFieldsContainer>
        <ErrorBox text={i18n.t.mileages.notNotifiedDialog.text} />

        <Table<MileageReminderNotNotified>
          hoverTr={false}
          fitWidth
          head={
            <>
              <th align="left">{i18n.t.drivers.singular}</th>
              <th align="left">{i18n.t.common.email}</th>
              <th align="left">{i18n.t.plateNumbers.singular}</th>
            </>
          }
          renderRow={(item) => (
            <>
              <td>{item.fullName}</td>
              <td>{item.email}</td>
              <Table.Td noWrap>{item.plateNumber}</Table.Td>
            </>
          )}
          items={notNotified}
        />
      </FormFieldsContainer>
    </ModalDialog>
  );
};

export default MileageRemindersNotNotifiedDialog;
